import { createSelector } from 'reselect'
import { groupBy } from '../../utils/helper'

const getActors = state => state.actors

const getFactions = createSelector(
    getActors,
    actors => groupBy(Object.values(actors), 'faction')
)

export default getFactions
